/**
 * BGM のオレンジの再生/停止ボタン (シナリオ編集画面の BGM セクションの採用中 BGM と同じ見た目:
 * /button_play_orange.svg ⇄ /button_stop_orange.svg)。audio 要素を内部に持ち、src が無いときは薄く表示して押せない。
 */
import { useEffect, useRef, useState } from 'react';
import { playExclusive } from '../../../utils/exclusiveAudio';

interface BgmOrangePlayButtonProps {
  src: string | null | undefined;
  size?: number;
}

export function BgmOrangePlayButton({ src, size = 24 }: BgmOrangePlayButtonProps) {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);

  // src が変わったら停止して作り直す (アンマウント時も停止)
  useEffect(() => {
    return () => {
      audioRef.current?.pause();
      audioRef.current = null;
      setPlaying(false);
    };
  }, [src]);

  const toggle = () => {
    if (!src) return;
    if (!audioRef.current) {
      const audio = document.createElement('audio');
      audio.preload = 'metadata';
      audio.src = src;
      audio.onplay = () => setPlaying(true);
      audio.onpause = () => setPlaying(false);
      audio.onended = () => setPlaying(false);
      audioRef.current = audio;
    }
    if (playing) audioRef.current.pause();
    else void playExclusive(audioRef.current).catch(() => setPlaying(false));
  };

  return (
    <button
      type="button"
      disabled={!src}
      onClick={toggle}
      title={!src ? '再生できる音源がありません' : playing ? '停止' : '再生'}
      aria-label={playing ? '停止' : '再生'}
      style={{ border: 'none', background: 'transparent', cursor: src ? 'pointer' : 'default', padding: 0, display: 'inline-flex', alignItems: 'center', opacity: src ? 1 : 0.35, flexShrink: 0 }}
    >
      <img src={playing ? '/button_stop_orange.svg' : '/button_play_orange.svg'} alt="" style={{ width: size, height: size }} />
    </button>
  );
}
